<template>
  <div class="ai-generate-create">
    <div class="ai-tabs-wrapper">
      <el-tabs v-model="activeTab" class="ai-tabs" :before-leave="handleBeforeLeave" @tab-click="handleTabClick">
        <el-tab-pane label="1. 选择数据源" name="source">
        <div class="content-layout">
          <div class="left-panel">
            <div class="panel-card">
              <div class="panel-title">源数据筛选</div>
              <div class="filter-row">
                <el-date-picker
                  v-model="sourceFilters.updateTimeRange"
                  type="daterange"
                  size="small"
                  value-format="timestamp"
                  :picker-options="datePickerOptions"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :disabled="isViewMode"
                  @change="handleDateChange"
                  class="filter-item"
                ></el-date-picker>
                <el-cascader
                  v-model="sourceFilters.taskPaths"
                  :options="taskCascaderOptions"
                  :props="{ multiple: true, checkStrictly: true }"
                  collapse-tags
                  clearable
                  filterable
                  placeholder="任务类型/任务"
                  size="small"
                  :disabled="isViewMode"
                  popper-class="ai-generate-cascader-popper"
                  class="filter-item cascader-filter"
                ></el-cascader>
                <el-input
                  v-model="sourceFilters.keyword"
                  size="small"
                  clearable
                  placeholder="标题关键词"
                  :disabled="isViewMode"
                  class="filter-item keyword-filter"
                ></el-input>
                <el-button type="primary" size="small" :disabled="isViewMode" @click="handleSourceSearch">
                  查询
                </el-button>
              </div>
            </div>

            <div class="panel-card">
              <div class="panel-title">
                源数据列表
                <span class="panel-sub">已选 {{ selectedRows.length }} 条</span>
              </div>
              <el-table
                ref="sourceTable"
                :data="sourceList"
                v-loading="sourceLoading"
                border
                height="calc(100vh - 370px)"
                :row-key="getRowDetailId"
                :reserve-selection="true"
                :selectable="isRowSelectable"
                @selection-change="handleSelectionChange"
              >
                <el-table-column type="selection" width="46"></el-table-column>
                <el-table-column prop="title" label="标题" min-width="200">
                  <template slot-scope="scope">
                    {{ scope.row.title || scope.row.name || '-' }}
                  </template>
                </el-table-column>
                <el-table-column prop="taskName" label="任务" width="120">
                  <template slot-scope="scope">
                    {{ scope.row.taskName || scope.row.task_name || '-' }}
                  </template>
                </el-table-column>
                <el-table-column prop="updateTime" label="更新时间" width="170">
                  <template slot-scope="scope">
                    {{ formatTime(scope.row.updateTime || scope.row.updateAt || scope.row.updatedAt) }}
                  </template>
                </el-table-column>
              </el-table>
              <div class="pagination-section">
                <el-pagination
                  @size-change="handleSourceSizeChange"
                  @current-change="handleSourcePageChange"
                  :current-page="sourcePagination.page"
                  :page-sizes="[10, 20, 50]"
                  :page-size="sourcePagination.pageSize"
                  :total="sourcePagination.total"
                  :disabled="isViewMode"
                  layout="total, sizes, prev, pager, next, jumper"
                ></el-pagination>
              </div>
            </div>
          </div>

          <div class="right-panel">
            <div class="panel-card selected-box">
              <div class="panel-title">已选清单</div>
              <div v-if="selectedRows.length" class="selected-list">
                <div v-for="item in selectedRows" :key="getRowDetailId(item)" class="selected-item">
                  <span class="selected-title">{{ item.title || item.name || '-' }}</span>
                  <el-button v-if="!isViewMode" type="text" size="mini" @click="removeSelected(item)">移除</el-button>
                </div>
              </div>
              <div v-else class="empty-tip">请从左侧列表选择至少 1 条内容</div>
            </div>
          </div>
        </div>
        </el-tab-pane>

        <el-tab-pane label="2. 选择生成提示语" name="prompt">
        <div class="tab-single">
          <div class="panel-card">
            <div class="panel-title">合并配置</div>
            <el-form label-width="92px" size="small" class="merge-form">
              <el-form-item label="提示词模板">
                <el-select
                  v-model="mergeForm.templateCode"
                  placeholder="选择模板"
                  class="full-width"
                  @change="handleTemplateChange"
                  :loading="templatesLoading"
                  :disabled="isViewMode"
                  clearable
                >
                  <el-option
                    v-for="template in templates"
                    :key="template.code"
                    :value="template.code"
                    :label="template.name"
                  >
                    <div class="template-option">
                      <div class="template-name">{{ template.name }}</div>
                      <div class="template-desc">{{ template.description }}</div>
                    </div>
                  </el-option>
                </el-select>
              </el-form-item>
            <el-form-item label="提示词内容" required class="prompt-item">
              <div :class="['vditor-container', isViewMode ? 'is-readonly' : '']">
                <div id="ai-merge-vditor"></div>
                <div v-if="vditorLoading" class="vditor-loading">
                  <i class="el-icon-loading"></i>
                  <span>编辑器加载中...</span>
                </div>
              </div>
            </el-form-item>
              <el-form-item label="合并模式">
                <el-select v-model="mergeForm.mergeMode" class="full-width" :disabled="isViewMode">
                  <el-option label="自动" value="AUTO"></el-option>
                  <el-option label="直接合并" value="DIRECT"></el-option>
                  <el-option label="分组聚合" value="GROUPED"></el-option>
                  <el-option label="分层提炼" value="LAYERED"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="图片识别">
                <el-switch v-model="mergeForm.enableRealtimeOCR" :disabled="isViewMode"></el-switch>
                <span class="switch-tip">对图片内容进行实时 OCR</span>
              </el-form-item>
            </el-form>
          </div>
        </div>
        </el-tab-pane>

        <el-tab-pane name="result" :disabled="!canEnterResult">
          <template slot="label">
            <span :class="['tab-label', (!canEnterResult && !isViewMode) ? 'is-disabled' : '']">3. 结果</span>
          </template>
          <div class="panel-card" v-if="currentRecordId">
            <div class="result-top-bar">
              <div class="progress-row">
                <div class="progress-compact">
                  <div class="progress-title">生成进度</div>
                  <div class="progress-main">
                    <div class="progress-meta">
                      <span>状态：{{ getStatusText(progressInfo.status) }}</span>
                      <span>步骤：{{ progressInfo.currentStep || '-' }}</span>
                      <span>耗时：{{ progressInfo.elapsedSeconds || 0 }}s</span>
                    </div>
                    <el-progress :percentage="progressInfo.progress" :status="progressStatus" :show-text="false"></el-progress>
                  </div>
                </div>
              </div>
              <div class="result-actions-group">
                <el-button
                  size="small"
                  :loading="updateLoading"
                  @click="updateResult"
                >
                  保存
                </el-button>
                <el-button
                  size="small"
                  :loading="exportLoading"
                  @click="exportPdf"
                >
                  导出 PDF
                </el-button>
                <el-button
                  type="primary"
                  size="small"
                  @click="openPublishPopup"
                  :disabled="!resultContent.trim()"
                >
                  发布为知识
                </el-button>
              </div>
            </div>
            <el-alert
              v-if="progressError"
              type="error"
              :closable="false"
              :title="progressError"
              class="progress-error-alert"
            ></el-alert>
          </div>

          <div class="panel-card mt-12" v-if="currentRecordId" v-loading="isGenerating" element-loading-text="正在生成内容，请稍候...">
            <div class="result-title-edit">
              <el-input
                v-model="resultTitle"
                size="small"
                placeholder="文章标题"
                class="title-input"
              ></el-input>
            </div>
            <div class="result-editor">
              <div :class="['vditor-container', isViewMode ? 'is-readonly' : '']">
                <div id="ai-merge-result-vditor"></div>
                <div v-if="resultVditorLoading || (!resultContent && progressInfo.status === 'COMPLETED')" class="vditor-loading">
                  <i class="el-icon-loading"></i>
                  <span>{{ resultContent ? '编辑器加载中...' : '内容加载中...' }}</span>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane v-if="!isViewMode && (activeTab === 'source' || activeTab === 'prompt')" name="actions" disabled>
          <template slot="label">
            <span class="tab-actions">
              <template v-if="activeTab === 'source'">
                <el-button size="small" :loading="saveLoading" @click.stop="saveMergeConfig">
                  保存
                </el-button>
                <el-button
                  type="primary"
                  size="small"
                  :loading="saveLoading"
                  @click.stop="handleNextStep"
                >
                  下一步
                </el-button>
              </template>
              <template v-else>
                <el-button size="small" :loading="saveLoading" @click.stop="saveMergeConfig">
                  保存
                </el-button>
                <el-button
                  type="primary"
                  size="small"
                  :loading="startLoading"
                  @click.stop="startMergeTask"
                >
                  开始生成
                </el-button>
              </template>
            </span>
          </template>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- 发布弹窗 -->
    <popup v-if="publishPopupVisible" @closeEvent="publishPopupVisible = false">
      <template slot="popup-name">发布为知识</template>
      <template slot="popup-con">
        <div class="publish-popup-content">
          <el-form label-width="80px" size="small">
            <el-form-item label="发布目录" required>
              <knowledge-directory-select
                v-model="publishForm.directory"
                :tree-data="directoryTreeData"
                :loading="directoryTreeLoading"
                placeholder="请选择发布目录"
              ></knowledge-directory-select>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template slot="dialog-footer">
        <el-button size="small" @click="publishPopupVisible = false">取消</el-button>
        <el-button
          type="primary"
          size="small"
          :loading="publishLoading"
          :disabled="!getSelectedDirectoryId(publishForm.directory)"
          @click="publishResult"
        >
          确认发布
        </el-button>
      </template>
    </popup>
  </div>
</template>

<script>
import MarkdownIt from "markdown-it";
import { getVditorInstanceConfig, preloadVditor } from "./vditor-config";
import KnowledgeDirectorySelect from "@/components/KnowledgeDirectorySelect.vue";
import Popup from "@/components/popup.vue";
import { requestUrl } from "@/http/requestUrl";
import { normalizeQuota, isQuotaExceeded } from "@/utils/quota";

let Vditor = null;
let VditorCSS = null;

export default {
  name: "aiGenerateKnowledgeCreate",
  components: {
    KnowledgeDirectorySelect,
    Popup
  },
  data() {
    const now = new Date();
    const defaultStart = new Date(now);
    defaultStart.setDate(defaultStart.getDate() - 6);
    defaultStart.setHours(0, 0, 0, 0);
    const defaultEnd = new Date(now);
    defaultEnd.setHours(23, 59, 59, 999);
    return {
      activeTab: "source",
      viewMode: "create",
      vditor: null,
      vditorLoading: false,
      vditorInitialized: false,
      resultVditor: null,
      resultVditorLoading: false,
      resultVditorInitialized: false,
      resultVditorSyncing: false,
      sourceLoading: false,
      sourceList: [],
      sourcePagination: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      sourceFilters: {
        updateTimeRange: [
          defaultStart.getTime(),
          defaultEnd.getTime()
        ],
        taskPaths: [],
        keyword: ""
      },
      taskCascaderOptions: [],
      datePickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setDate(start.getDate() - 6);
              picker.$emit("pick", [start.getTime(), end.getTime()]);
              setTimeout(() => {
                const btns = document.querySelectorAll(".el-picker-panel__shortcut");
                btns.forEach(btn => {
                  if (btn.innerText === "最近一周") {
                    btn.classList.add("is-active");
                  } else {
                    btn.classList.remove("is-active");
                  }
                });
              }, 0);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setDate(start.getDate() - 29);
              picker.$emit("pick", [start.getTime(), end.getTime()]);
              setTimeout(() => {
                const btns = document.querySelectorAll(".el-picker-panel__shortcut");
                btns.forEach(btn => {
                  if (btn.innerText === "最近一个月") {
                    btn.classList.add("is-active");
                  } else {
                    btn.classList.remove("is-active");
                  }
                });
              }, 0);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 3);
              picker.$emit("pick", [start.getTime(), end.getTime()]);
              setTimeout(() => {
                const btns = document.querySelectorAll(".el-picker-panel__shortcut");
                btns.forEach(btn => {
                  if (btn.innerText === "最近三个月") {
                    btn.classList.add("is-active");
                  } else {
                    btn.classList.remove("is-active");
                  }
                });
              }, 0);
            }
          },
          {
            text: "本月",
            onClick(picker) {
              const end = new Date();
              const start = new Date(end.getFullYear(), end.getMonth(), 1);
              picker.$emit("pick", [start.getTime(), end.getTime()]);
              setTimeout(() => {
                const btns = document.querySelectorAll(".el-picker-panel__shortcut");
                btns.forEach(btn => {
                  if (btn.innerText === "本月") {
                    btn.classList.add("is-active");
                  } else {
                    btn.classList.remove("is-active");
                  }
                });
              }, 0);
            }
          },
          {
            text: "上月",
            onClick(picker) {
              const now = new Date();
              const start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
              const end = new Date(now.getFullYear(), now.getMonth(), 0);
              picker.$emit("pick", [start.getTime(), end.getTime()]);
              setTimeout(() => {
                const btns = document.querySelectorAll(".el-picker-panel__shortcut");
                btns.forEach(btn => {
                  if (btn.innerText === "上月") {
                    btn.classList.add("is-active");
                  } else {
                    btn.classList.remove("is-active");
                  }
                });
              }, 0);
            }
          }
        ]
      },
      selectedRows: [],
      templates: [],
      templatesLoading: false,
      mergeForm: {
        templateCode: "",
        promptText: "",
        mergeMode: "AUTO",
        enableRealtimeOCR: false
      },
      startLoading: false,
      saveLoading: false,
      currentRecordId: "",
      saveRecordId: "",
      progressInfo: {
        progress: 0,
        status: "",
        currentStep: "",
        elapsedSeconds: 0
      },
      progressError: "",
      progressTimer: null,
      hasStarted: false,
      resultData: null,
      resultContent: "",
      resultTitle: "",
      resultMarkdownHtml: "",
      markdownRenderer: null,
      publishForm: {
        directory: null
      },
      directoryTreeLoading: false,
      directoryTreeData: [],
      publishLoading: false,
      publishPopupVisible: false,
      fallbackLoadedRecordIds: {},
      updateLoading: false,
      exportLoading: false,
      tokenQuota: {
        checked: false,
        exceeded: false,
        used: null,
        total: null
      },
      tokenQuotaChecking: false
    };
  },
  computed: {
    isViewMode() {
      return this.viewMode === "view";
    },
    canPublish() {
      return (
        !!this.resultContent.trim() &&
        !!this.getSelectedDirectoryId(this.publishForm.directory) &&
        !this.publishLoading
      );
    },
    canEnterResult() {
      if (this.isViewMode) return true;
      if (!this.hasStarted) return false;
      if (!this.progressInfo.status) return false;
      return !["FAILED", "PENDING"].includes(this.progressInfo.status || "");
    },
    selectedDetailIds() {
      return this.selectedRows
        .map(row => this.getRowDetailId(row))
        .filter(id => id !== null && id !== undefined && id !== "");
    },
    progressStatus() {
      if (this.progressInfo.status === "FAILED") return "exception";
      if (this.progressInfo.status === "COMPLETED") return "success";
      return "active";
    },
    isGenerating() {
      return this.progressInfo.status === "PROCESSING" || this.progressInfo.status === "PENDING";
    }
  },
  mounted() {
    this.markdownRenderer = new MarkdownIt({
      html: true,
      linkify: true
    });
    preloadVditor();
    this.fetchSourceList();
    this.fetchTemplates();
    this.fetchTaskCascaderOptions();
    this.applyRouteMode();
    this.fetchTokenQuota();
  },
  watch: {
    resultContent(value) {
      if (!this.markdownRenderer) return;
      this.resultMarkdownHtml = value ? this.markdownRenderer.render(value) : "";
      this.safeSetResultVditorValue(value || "");
    },
    activeTab(value) {
      if (value === "prompt") {
        this.initVditorLazy();
      }
      if (value === "result" && this.currentRecordId) {
        if (this.hasStarted) {
          this.startProgressPolling();
          if (this.resultData) {
            this.initResultVditorLazy();
          }
        } else {
          this.clearProgressTimer();
          this.progressError = "";
          this.progressInfo = {
            progress: 0,
            status: "",
            currentStep: "",
            elapsedSeconds: 0
          };
        }
      }
      if (value === "prompt" || value === "source") {
        this.ensureRecordConfigLoaded(value);
      }
    },
    "mergeForm.promptText"(value) {
      if (this.vditor && value !== this.vditor.getValue()) {
        this.vditor.setValue(value || "");
      }
    },
    $route() {
      this.applyRouteMode();
    }
  },
  beforeDestroy() {
    this.clearProgressTimer();
    this.destroyVditor();
    this.destroyResultVditor();
  },
  methods: {
    async handleBeforeLeave(activeName) {
      console.log("[Debug] handleBeforeLeave", {
        activeName,
        hasStarted: this.hasStarted,
        status: this.progressInfo.status,
        canEnterResult: this.canEnterResult,
        viewMode: this.viewMode
      });
      if (this.isViewMode) return true;

      // 进入 提示语 或 结果 标签页，必须先选择数据源
      if (activeName === "prompt" || activeName === "result") {
        if (this.selectedRows.length === 0) {
          this.$message.warning("请至少选择一条源数据内容");
          return false;
        }
      }

      // 进入 结果 标签页，必须先配置提示语
      if (activeName === "result") {
        if (this.currentRecordId) {
          await this.fetchProgress();
        }
        if (!this.canEnterResult) {
          this.$message.warning("未开始生成，无法查看");
          return false;
        }
        const promptValue = this.vditor ? this.vditor.getValue() : this.mergeForm.promptText;
        if (!promptValue || promptValue.trim() === "" || promptValue.trim() === "\n") {
          this.$message.warning("请先在提示语步骤完善提示词内容");
          return false;
        }
      }
      return true;
    },
    handleTabClick(tab) {
      console.log("[Debug] handleTabClick", {
        name: tab && tab.name,
        hasStarted: this.hasStarted,
        status: this.progressInfo.status,
        canEnterResult: this.canEnterResult,
        viewMode: this.viewMode
      });
      if (tab && tab.name === "result" && !this.canEnterResult) {
        this.$message.warning("未开始生成，无法查看");
        if (this.activeTab === "result") {
          this.activeTab = "prompt";
        }
      }
    },
    applyRouteMode() {
      const { mode, recordId } = this.$route.query || {};
      this.viewMode = mode || "create";
      if (recordId) {
        this.initFromRecord(recordId);
      }
      if (recordId && mode === "edit") {
        this.fetchMergeConfigDetail(recordId);
      }
    },
    initFromRecord(recordId) {
      if (this.currentRecordId && this.currentRecordId !== recordId) {
        this.resultVditorInitialized = false;
        this.vditorInitialized = false;
      }
      this.saveRecordId = recordId;
      this.currentRecordId = recordId;

      const cache = JSON.parse(sessionStorage.getItem("ai_merge_record_cache") || "{}");
      const record = cache[recordId];

      if (record) {
        this.syncStateFromRecord(record);
        this.finalizeInitialization(record);
      } else {
        // 无有效缓存或缺少关键字段，尝试从后端加载
        const loadFromBackend = async () => {
          try {
            // 尝试 1: 获取合并进展（包含大部分实时状态）
            const progressRes = await this.$http.get(`${requestUrl.collection.taskResultMergeProgress}/${recordId}`);
            if (progressRes.data && progressRes.data.code === "0" && progressRes.data.data) {
              const data = progressRes.data.data;
              this.syncStateFromRecord(data);
              // 如果已有配置，可以提前结束
              if (data.detailIds || data.detailIdList || data.customPrompt) {
                this.finalizeInitialization(data);
                return;
              }
            }

            // 尝试 2: 获取合并结果
            const resultRes = await this.$http.get(`${requestUrl.collection.taskResultMergeResult}/${recordId}`);
            if (resultRes.data && resultRes.data.code === "0" && resultRes.data.data) {
              const data = resultRes.data.data;
              this.syncStateFromRecord(data);
              if (data.detailIds || data.detailIdList || data.customPrompt) {
                this.finalizeInitialization(data);
                return;
              }
            }

            // 尝试 3: 搜索历史记录（历史记录通常包含最初保存的 detailIds）
            const historyRes = await this.$http.get(requestUrl.collection.taskResultMergeHistory, {
              params: { page: 1, pageSize: 100 }
            });
            if (historyRes.data && historyRes.data.code === "0") {
              const list = historyRes.data.data.list || historyRes.data.data.records || [];
              const found = list.find(item => 
                String(item.id) === String(recordId) || 
                String(item.recordId) === String(recordId) ||
                String(item.mergeRecordId) === String(recordId)
              );
              if (found) {
                this.syncStateFromRecord(found);
                this.finalizeInitialization(found);
                return;
              }
            }
          } catch (error) {
            console.error("[Debug] loadFromBackend caught error:", error);
          }
          
          // 兜底：即使没找到详情，也要初始化界面
          this.finalizeInitialization(record || {});
        };

        loadFromBackend();
      }
    },
    syncStateFromRecord(data) {
      if (!data) return;
      
      // 使用合并而非直接赋值
      this.resultData = { ...(this.resultData || {}), ...data };

      const mergeConfig = this.extractMergeConfig(data);
      if (data.status) {
        this.hasStarted = ["PENDING", "PROCESSING", "COMPLETED", "FAILED"].includes(data.status);
      }
      
      const recordId = data.recordId || data.id || data.mergeRecordId;
      if (recordId) {
        this.saveRecordId = recordId;
        this.currentRecordId = recordId;
      }
      
      // 1. 同步结果内容
      if (data.content && !this.resultContent) {
        this.resultContent = data.content;
      }
      
      // 2. 同步提示词模板
      const templateCode = data.templateCode ||
        data.template_code ||
        data.template ||
        (mergeConfig && (mergeConfig.templateCode || mergeConfig.template_code));
      if (templateCode && !this.mergeForm.templateCode) {
        this.mergeForm.templateCode = templateCode;
      }
      
      // 3. 同步提示词内容 ( Aggressive Search )
      const prompt = data.customPrompt ||
        data.userPrompt ||
        data.prompt ||
        data.configPrompt ||
        data.promptText ||
        data.prompt_text ||
        data.promptContent ||
        data.prompt_content ||
        data.mergePrompt ||
        data.user_prompt ||
        data.custom_prompt ||
        (mergeConfig && (mergeConfig.customPrompt || mergeConfig.userPrompt || mergeConfig.prompt || mergeConfig.promptText || mergeConfig.prompt_content));
      
      if (prompt && (!this.mergeForm.promptText || this.isViewMode)) {
        this.mergeForm.promptText = prompt;
        // 强制同步到 Vditor
        if (this.vditor && this.vditorInitialized) {
          this.vditor.setValue(prompt);
        }
      }
      
      // 4. 同步其他配置
      const mergeMode = data.mergeMode || (mergeConfig && mergeConfig.mergeMode);
      if (mergeMode) {
        this.mergeForm.mergeMode = mergeMode;
      }
      if (Object.prototype.hasOwnProperty.call(data, "enableRealtimeOcr")) {
        this.mergeForm.enableRealtimeOCR = !!data.enableRealtimeOcr;
      } else if (mergeConfig && Object.prototype.hasOwnProperty.call(mergeConfig, "enableRealtimeOcr")) {
        this.mergeForm.enableRealtimeOCR = !!mergeConfig.enableRealtimeOcr;
      }
      
      // 5. 同步已选清单 ( Aggressive Search )
      const detailListRaw = data.detailList ||
        data.detail_list ||
        data.details ||
        data.sourceList ||
        data.sources ||
        (mergeConfig && (mergeConfig.detailList || mergeConfig.detail_list));

      if (Array.isArray(detailListRaw) && detailListRaw.length > 0 && typeof detailListRaw[0] === "object") {
        this.selectedRows = detailListRaw;
        this.$nextTick(() => {
          if (this.$refs.sourceTable) {
            this.syncTableSelection();
          }
        });
        return;
      }

      const detailIdsRaw = data.detailIds ||
        data.detailIdList ||
        data.detailIdListJson ||
        data.detailIdsJson ||
        data.detailIdsStr ||
        data.detailIdStr ||
        data.targetIdList ||
        data.ids ||
        data.idList ||
        data.recordIds ||
        data.detail_ids ||
        data.detail_id_list ||
        data.itemIds ||
        data.sourceIds ||
        data.sourceIdList ||
        data.source_id_list ||
        data.sourceIdsJson ||
        data.sourceIdsStr ||
        (mergeConfig && (mergeConfig.detailIds || mergeConfig.detailIdList || mergeConfig.detail_ids || mergeConfig.detailIdStr));
      
      const detailIds = this.parseIdList(detailIdsRaw);
      
      if (detailIds.length > 0) {
        const currentIds = this.selectedRows.map(row => String(this.getRowDetailId(row)));
        const isSame = detailIds.length === currentIds.length && detailIds.every((id, index) => String(id) === String(currentIds[index]));
        
        if (!isSame) {
          this.selectedRows = detailIds.map(id => ({
            detailId: id,
            title: `正在获取 ID ${id} 的标题...`
          }));
          this.fetchSelectedDetails(detailIds);
        }
      }

      if ((!this.selectedRows.length || !this.mergeForm.promptText) && recordId) {
        // 如果依然没有找到，尝试二次回溯
        this.fetchConfigFallback(recordId);
      }
    },
    ensureRecordConfigLoaded(targetTab) {
      if (!this.currentRecordId) return;
      const needPrompt = targetTab === "prompt" && !this.mergeForm.promptText;
      const needSource = targetTab === "source" && !this.selectedRows.length;
      if (!needPrompt && !needSource) return;
      if (!this.mergeForm.promptText || !this.selectedRows.length) {
        this.fetchMergeConfigDetail(this.currentRecordId);
      }
      if (!this.hasStarted) {
        return;
      }
      if (this.progressInfo.status === "COMPLETED" || (this.resultData && this.resultData.content)) {
        this.fetchResult();
      } else {
        this.fetchProgress();
      }
    },
    fetchMergeConfigDetail(recordId) {
      if (!recordId || this._mergeConfigLoading) return;
      this._mergeConfigLoading = true;
      this.$http
        .get(`${requestUrl.collection.taskResultMergeDetail}/${recordId}`)
        .then(res => {
          if (res.data && res.data.code === "0") {
            const data = res.data.data || {};
            this.syncStateFromRecord(data);
          }
        })
        .catch(error => {
          console.error("fetchMergeConfigDetail error:", error);
        })
        .finally(() => {
          this._mergeConfigLoading = false;
        });
    },
    fetchConfigFallback(recordId) {
      if (!recordId || this._fallbackFetching || this.fallbackLoadedRecordIds[recordId]) return;
      this._fallbackFetching = true;
      this.fallbackLoadedRecordIds[recordId] = true;
      
      this.$http.get(requestUrl.collection.taskResultMergeHistory, {
        params: { page: 1, pageSize: 100, recordId, includeConfig: true }
      }).then(res => {
        if (res.data && res.data.code === "0") {
          const list = res.data.data.list || res.data.data.records || [];
          const found = list.find(item => 
            String(item.id) === String(recordId) || 
            String(item.recordId) === String(recordId) ||
            String(item.mergeRecordId) === String(recordId)
          );
          if (found) {
            this.syncStateFromRecord(found);
          }
        }
      }).finally(() => {
        this._fallbackFetching = false;
      });
    },
    fetchSelectedDetails(detailIds) {
      if (!detailIds || !detailIds.length) return;
      
      const promises = detailIds.map(id => 
        this.$http.get(`${requestUrl.collection.taskResultDetail}${id}`)
          .then(res => (res.data && res.data.code === "0") ? res.data.data : null)
          .catch(() => null)
      );

      Promise.all(promises).then(results => {
        const validResults = results.filter(r => r !== null);
        if (validResults.length > 0) {
          this.selectedRows = detailIds.map(id => {
            const found = validResults.find(r => String(this.getRowDetailId(r)) === String(id));
            return found || { detailId: id, title: `采集ID ${id}` };
          });

          this.$nextTick(() => {
            if (this.$refs.sourceTable) {
              this.syncTableSelection();
            }
          });
        }
      });
    },
    finalizeInitialization(record) {
      if (this.viewMode === "view") {
        this.activeTab = "result";
        if (record && (record.status === "COMPLETED" || record.progress === 100)) {
          this.fetchResult();
        } else {
          this.fetchProgress();
          this.startProgressPolling();
        }
      } else {
        this.activeTab = "source";
      }
    },
    parseIdList(value) {
      if (!value) return [];
      if (Array.isArray(value)) {
        return value
          .map(item => {
            if (item && typeof item === "object") {
              return this.getRowDetailId(item) || item.detailId || item.id || item.resultId || item.recordId;
            }
            return item;
          })
          .filter(item => item !== null && item !== undefined && item !== "")
          .map(item => String(item));
      }
      if (typeof value === "string") {
        try {
          const parsed = JSON.parse(value);
          return Array.isArray(parsed) ? parsed : [];
        } catch (error) {
          return value
            .replace(/[\[\]\s]/g, "")
            .split(",")
            .map(item => item.trim())
            .filter(Boolean)
            .map(item => Number(item))
            .filter(item => !Number.isNaN(item));
        }
      }
      return [];
    },
    extractMergeConfig(data) {
      if (!data || typeof data !== "object") return null;
      const raw = data.mergeConfig ||
        data.merge_config ||
        data.mergeConfigJson ||
        data.merge_config_json ||
        data.configJson ||
        data.config_json ||
        data.mergeConfigDto ||
        data.merge_config_dto ||
        data.mergeConfigDTO ||
        data.merge_config_DTO ||
        data.config ||
        data.mergeConfigStr;
      if (!raw) return null;
      if (typeof raw === "object") return raw;
      if (typeof raw === "string") {
        try {
          return JSON.parse(raw);
        } catch (error) {
          return null;
        }
      }
      return null;
    },
    async loadVditor() {
      if (Vditor && VditorCSS) {
        return { Vditor, VditorCSS };
      }
      const [vditorModule, vditorCSSModule] = await Promise.all([
        import("vditor"),
        import("vditor/dist/index.css")
      ]);
      Vditor = vditorModule.default;
      VditorCSS = vditorCSSModule.default;
      return { Vditor, VditorCSS };
    },
    async initVditorLazy() {
      if (this.vditorInitialized && this.vditor) {
        this.vditor.setValue(this.mergeForm.promptText || "");
        return;
      }
      if (!this.vditorLoading) {
        this.vditorLoading = true;
      }
      try {
        await this.loadVditor();
        this.initVditor();
        this.vditorInitialized = true;
      } catch (error) {
        console.error("initVditorLazy error:", error);
        this.vditorLoading = false;
      }
    },
    initVditor() {
      if (this.vditor) {
        this.vditor.destroy();
      }
      const config = getVditorInstanceConfig({
        value: this.mergeForm.promptText || "",
        height: "100%",
        readOnly: this.isViewMode,
        after: () => {
          if (this.vditorLoading) {
            setTimeout(() => {
              this.vditorLoading = false;
            }, 200);
          }
        },
        input: (value) => {
          this.mergeForm.promptText = value;
        }
      });
      this.vditor = new Vditor("ai-merge-vditor", config);
    },
    async initResultVditorLazy() {
      if (!this.resultData) return;
      await this.$nextTick();
      const container = document.getElementById("ai-merge-result-vditor");
      if (!container) {
        return;
      }
      if (this.resultVditor && !this.resultVditor.element) {
        this.resultVditor = null;
        this.resultVditorInitialized = false;
      }
      if (this.resultVditorInitialized && this.resultVditor) {
        this.safeSetResultVditorValue(this.resultContent || "");
        return;
      }
      if (!this.resultVditorLoading) {
        this.resultVditorLoading = true;
      }
      try {
        await this.loadVditor();
        this.initResultVditor();
        this.resultVditorInitialized = true;
      } catch (error) {
        console.error("initResultVditorLazy error:", error);
        this.resultVditorLoading = false;
      }
    },
    initResultVditor() {
      const container = document.getElementById("ai-merge-result-vditor");
      if (!container) {
        this.resultVditorLoading = false;
        return;
      }
      if (this.resultVditor && this.resultVditor.element) {
        try {
          this.resultVditor.destroy();
        } catch (error) {
          console.warn("destroy resultVditor failed:", error);
        }
      }
      this.resultVditorSyncing = true;
      let initialValue = this.resultContent || "";
      if (initialValue.trim().startsWith("---")) {
        initialValue = initialValue.replace(/^\s*---\s*/, "");
      }

      const config = getVditorInstanceConfig({
        value: initialValue,
        height: "100%",
        readOnly: this.isViewMode,
        after: () => {
          // 不再强制设置为只读，或者允许在 view 模式下也可以编辑
          this.resultVditor?.setReadOnly?.(false);
          setTimeout(() => {
            this.resultVditorSyncing = false;
          }, 300);
          if (this.resultVditorLoading) {
            setTimeout(() => {
              this.resultVditorLoading = false;
            }, 200);
          }
        },
        input: (value) => {
          if (this.resultVditorSyncing) return;
          this.resultContent = value;
        }
      });
      this.resultVditor = new Vditor("ai-merge-result-vditor", config);
    },
    safeSetResultVditorValue(value) {
      if (!this.resultVditor) return;

      const performSet = () => {
        if (!this.resultVditor || !this.resultVditor.element) return;
        // 如果当前内容已经和要设置的内容一致，不再重复设置，避免某些模式下的光标跳动
        if (this.resultVditor.getValue() === (value || "")) return;
        
        try {
          this.resultVditorSyncing = true;
          // 防止 Vditor 将开头的 --- 解析为 Front Matter
          let cleanValue = value || "";
          if (cleanValue.trim().startsWith("---")) {
             // 移除开头的 --- 及紧随的空白字符
             cleanValue = cleanValue.replace(/^\s*---\s*/, "");
          }
          this.resultVditor.setValue(cleanValue);
          setTimeout(() => {
            this.resultVditorSyncing = false;
          }, 300);
        } catch (error) {
          console.warn("safeSetResultVditorValue failed:", error);
          this.resultVditorSyncing = false;
        }
      };

      // 如果 Vditor 还没准备好（currentMode 未定义通常意味着还没完成内部初始化）
      if (this.resultVditor && typeof this.resultVditor.currentMode === "undefined") {
        if (this._resultVditorCheckTimer) {
          clearInterval(this._resultVditorCheckTimer);
        }
        let attempts = 0;
        this._resultVditorCheckTimer = setInterval(() => {
          attempts++;
          if (this.resultVditor && typeof this.resultVditor.currentMode !== "undefined") {
            clearInterval(this._resultVditorCheckTimer);
            this._resultVditorCheckTimer = null;
            performSet();
          } else if (attempts > 30) {
            // 最多等待 3 秒
            clearInterval(this._resultVditorCheckTimer);
            this._resultVditorCheckTimer = null;
            console.warn("safeSetResultVditorValue: Vditor ready timeout");
          }
        }, 100);
        return;
      }

      performSet();
    },
    destroyResultVditor() {
      if (this.resultVditor && this.resultVditor.element) {
        try {
          this.resultVditor.destroy();
        } catch (error) {
          console.warn("destroyResultVditor failed:", error);
        }
        this.resultVditor = null;
        this.resultVditorInitialized = false;
      }
    },
    destroyVditor() {
      if (this.vditor) {
        this.vditor.destroy();
        this.vditor = null;
        this.vditorInitialized = false;
      }
    },
    handleDateChange() {
      // 当手动选择日期时，清除快捷选项的高亮态
      const btns = document.querySelectorAll(".el-picker-panel__shortcut");
      btns.forEach(btn => btn.classList.remove("is-active"));
    },
    handleSourceSearch() {
      this.sourcePagination.page = 1;
      this.fetchSourceList();
    },
    fetchSourceList() {
      if (this.sourceLoading) return;
      this.sourceLoading = true;
      const params = {
        page: this.sourcePagination.page,
        pageSize: this.sourcePagination.pageSize
      };
      if (Array.isArray(this.sourceFilters.updateTimeRange)) {
        const [start, end] = this.sourceFilters.updateTimeRange;
        if (start) {
          params.updateTimeStart = start;
        }
        if (end) {
          const sameDay = start && new Date(start).toDateString() === new Date(end).toDateString();
          const normalizedEnd = sameDay ? end + 24 * 60 * 60 * 1000 - 1 : end + 24 * 60 * 60 * 1000 - 1;
          params.updateTimeEnd = normalizedEnd;
        }
      }
      if (this.sourceFilters.keyword) {
        params.keyword = this.sourceFilters.keyword.trim();
      }

      // 处理级联选择器选中的任务和类型
      if (Array.isArray(this.sourceFilters.taskPaths) && this.sourceFilters.taskPaths.length > 0) {
        const taskIds = [];
        const siteTypes = [];
        this.sourceFilters.taskPaths.forEach(path => {
          // path 类型如 ['WEBSITE'] 或 ['WEBSITE', 123]
          if (path.length === 1) {
            siteTypes.push(path[0]);
          } else if (path.length === 2) {
            taskIds.push(path[1]);
          }
        });
        if (taskIds.length > 0) {
          params.taskIds = taskIds;
        }
        if (siteTypes.length > 0) {
          params.siteTypes = siteTypes;
        }
      }

      this.$http
        .post(requestUrl.collection.taskResultSearch, params)
        .then(res => {
          if (res.data && res.data.code === "0") {
            const pageData = res.data.data || {};
            const list = Array.isArray(pageData.list)
              ? pageData.list
              : Array.isArray(pageData.records)
                ? pageData.records
                : [];
            this.sourceList = list;
            this.sourcePagination.total = pageData.total || 0;
            this.$nextTick(() => {
              this.syncTableSelection();
            });
          } else {
            this.$message.error(res.data && res.data.message ? res.data.message : "获取源数据失败");
          }
        })
        .catch(error => {
          console.error("fetchSourceList error:", error);
          this.$message.error("获取源数据失败，请稍后重试");
        })
        .finally(() => {
          this.sourceLoading = false;
        });
    },
    handleSourcePageChange(page) {
      this.sourcePagination.page = page;
      this.fetchSourceList();
    },
    handleSourceSizeChange(size) {
      this.sourcePagination.pageSize = size;
      this.sourcePagination.page = 1;
      this.fetchSourceList();
    },
    handleSelectionChange(selection) {
      if (this.isViewMode) return;
      const currentSelection = Array.isArray(selection) ? selection : [];
      const selectedIds = new Set(
        currentSelection
          .map(row => this.getRowDetailId(row))
          .filter(id => id !== null && id !== undefined && id !== "")
      );
      const pageIds = new Set(
        this.sourceList
          .map(row => this.getRowDetailId(row))
          .filter(id => id !== null && id !== undefined && id !== "")
      );
      const merged = [];
      this.selectedRows.forEach(row => {
        const rowId = this.getRowDetailId(row);
        if (!rowId) return;
        if (!pageIds.has(rowId) || selectedIds.has(rowId)) {
          merged.push(row);
        }
      });
      currentSelection.forEach(row => {
        const rowId = this.getRowDetailId(row);
        if (!rowId) return;
        if (!merged.some(item => this.getRowDetailId(item) === rowId)) {
          merged.push(row);
        }
      });
      this.selectedRows = merged;
    },
    removeSelected(row) {
      if (this.isViewMode) return;
      const rowId = this.getRowDetailId(row);
      if (rowId) {
        this.selectedRows = this.selectedRows.filter(item => this.getRowDetailId(item) !== rowId);
      }
      if (this.$refs.sourceTable && this.$refs.sourceTable.toggleRowSelection) {
        this.$refs.sourceTable.toggleRowSelection(row, false);
      }
    },
    syncTableSelection() {
      if (!this.$refs.sourceTable || !this.$refs.sourceTable.toggleRowSelection) {
        return;
      }
      const selectedIds = new Set(
        this.selectedRows
          .map(row => this.getRowDetailId(row))
          .filter(id => id !== null && id !== undefined && id !== "")
      );
      this.$refs.sourceTable.clearSelection();
      this.sourceList.forEach(row => {
        const rowId = this.getRowDetailId(row);
        if (rowId && selectedIds.has(rowId)) {
          this.$refs.sourceTable.toggleRowSelection(row, true);
        }
      });
    },
    getRowDetailId(row) {
      if (!row || typeof row !== "object") {
        return null;
      }
      return row.detailId || row.id || row.resultId || row.recordId || null;
    },
    formatTime(time) {
      if (!time) return "-";
      const date = new Date(time);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    fetchTemplates() {
      if (this.templatesLoading) return;
      this.templatesLoading = true;
      this.$http
        .get(requestUrl.collection.taskResultMergeTemplates)
        .then(res => {
          if (res.data && res.data.code === "0") {
            this.templates = Array.isArray(res.data.data) ? res.data.data : [];
          } else {
            this.$message.error(res.data && res.data.message ? res.data.message : "获取模板失败");
          }
        })
        .catch(error => {
          console.error("fetchTemplates error:", error);
          this.$message.error("获取模板失败，请稍后重试");
        })
        .finally(() => {
          this.templatesLoading = false;
        });
    },
    handleTemplateChange(code) {
      if (this.isViewMode) return;
      const current = this.templates.find(item => item.code === code);
      if (current && current.defaultPrompt) {
        this.mergeForm.promptText = current.defaultPrompt;
        if (this.vditor && this.activeTab === "prompt") {
          this.vditor.setValue(this.mergeForm.promptText);
        }
      } else if (!code) {
        this.mergeForm.promptText = "";
        if (this.vditor && this.activeTab === "prompt") {
          this.vditor.setValue("");
        }
      }
    },
    isRowSelectable() {
      return !this.isViewMode;
    },
    async fetchTokenQuota() {
      if (this.tokenQuotaChecking) return this.tokenQuota;
      this.tokenQuotaChecking = true;
      try {
        const res = await this.$http.get(requestUrl.company.getUserCompanyModule);
        const payload = (res.data && res.data.data) ? res.data.data : (res.data || {});
        const companyConfig = payload.companyConfig || {};
        let quota = normalizeQuota(payload, {
          usedKeys: ["tokenUsed", "usedTokens", "flowUsed", "usedFlow", "useFlow", "usedToken", "llmTokenUsed"],
          totalKeys: ["tokenTotal", "totalTokens", "flowTotal", "totalFlow", "maxTokens", "maxFlow", "llmTokenLimit"],
          remainingKeys: ["canUsedFlow", "flowSurplus", "tokenSurplus", "remainingTokens"]
        });
        if (typeof companyConfig.llmTokenLimit === "number") {
          quota = {
            ...quota,
            total: companyConfig.llmTokenLimit
          };
        }
        const usedRes = await this.$http.post("/portal-api/token-usage/logs/page", {
          pageNo: 1,
          pageSize: 1
        });
        const usedPayload = (usedRes.data && usedRes.data.data) ? usedRes.data.data : usedRes.data;
        let usedValue = usedPayload && typeof usedPayload === "object"
          ? (typeof usedPayload.totalTokens === "number"
            ? usedPayload.totalTokens
            : (Number(usedPayload.promptTokens || 0) + Number(usedPayload.completionTokens || 0)))
          : null;
        if (usedValue === null && usedRes.data && usedRes.data.code === "5001") {
          usedValue = 0;
        }
        if (typeof usedValue === "number" && !Number.isNaN(usedValue)) {
          quota = {
            ...quota,
            used: usedValue
          };
        }
        this.tokenQuota = {
          checked: true,
          exceeded: quota.total === 0 || quota.total === null ? true : isQuotaExceeded(quota),
          used: quota.used,
          total: quota.total
        };
      } catch (error) {
        console.error("fetchTokenQuota error:", error);
        this.tokenQuota.checked = true;
      } finally {
        this.tokenQuotaChecking = false;
      }
      return this.tokenQuota;
    },
    async ensureTokenQuota() {
      if (this.isViewMode) return true;
      const quota = await this.fetchTokenQuota();
      if (quota.exceeded) {
        this.$message.warning("Token已经使用完，请联系商务购买。");
        return false;
      }
      return true;
    },
    startMergeTask() {
      if (!this.selectedDetailIds.length) {
        this.$message.warning("请先选择数据源");
        return;
      }
      if (!this.mergeForm.promptText || !this.mergeForm.promptText.trim()) {
        this.$message.warning("请先填写提示词内容");
        return;
      }
      const ensureRecordId = () => {
        // 无论是否有 recordId，都强制调用 saveMergeConfig 以便保存最新的 prompt
        return this.saveMergeConfig().then(success => {
          if (!success) return "";
          return this.saveRecordId || this.currentRecordId || "";
        });
      };
      this.startLoading = true;
      this.progressError = "";
      ensureRecordId()
        .then(recordId => {
          if (!recordId) {
            if (this.tokenQuota.exceeded) {
              return;
            }
            this.$message.error("保存失败，无法开始生成");
            return;
          }
          return this.$http.post(`${requestUrl.collection.taskResultMergeStart}/${recordId}`)
            .then(res => {
              if (res.data && res.data.code === "0") {
                this.currentRecordId = recordId;
                this.hasStarted = true;
                this.progressInfo = {
                  progress: 0,
                  status: "PENDING",
                  currentStep: "",
                  elapsedSeconds: 0
                };
                this.resultData = null;
                this.resultContent = "";
                this.resultMarkdownHtml = "";
                this.activeTab = "result";
                this.startProgressPolling();
              } else {
                this.$message.error(res.data && res.data.message ? res.data.message : "启动失败");
              }
            });
        })
        .catch(error => {
          console.error("startMergeTask error:", error);
          this.$message.error("启动失败，请稍后重试");
        })
        .finally(() => {
          this.startLoading = false;
        });
    },
    async saveMergeConfig() {
      if (this.saveLoading) return Promise.resolve(false);
      const canCreate = await this.ensureTokenQuota();
      if (!canCreate) return Promise.resolve(false);
      if (this.vditor) {
        this.mergeForm.promptText = this.vditor.getValue();
      }
      const payload = {
        detailIds: this.selectedDetailIds
      };
      const recordId = this.saveRecordId || this.currentRecordId;
      if (recordId) {
        payload.recordId = recordId;
      }
      if (this.mergeForm.templateCode) {
        payload.templateCode = this.mergeForm.templateCode;
      }
      if (this.mergeForm.promptText) {
        payload.customPrompt = this.mergeForm.promptText;
      }
      payload.enableRealtimeOcr = !!this.mergeForm.enableRealtimeOCR;
      payload.enable_realtime_ocr = !!this.mergeForm.enableRealtimeOCR;

      // 验证是否选择了数据
      if (!payload.detailIds || payload.detailIds.length === 0) {
        this.$message.warning("请选择数据");
        return Promise.resolve(false);
      }
      this.saveLoading = true;
      return this.$http
        .post(requestUrl.collection.taskResultMergeSave, payload)
        .then(res => {
          if (res.data && res.data.code === "0") {
            const data = res.data.data || {};
            if (data.recordId) {
              this.saveRecordId = data.recordId;
            }
            this.$message.success("保存成功");
            return true;
          }
          this.$message.error(res.data && res.data.message ? res.data.message : "保存失败");
          return false;
        })
        .catch(error => {
          console.error("saveMergeConfig error:", error);
          this.$message.error("保存失败，请稍后重试");
          return false;
        })
        .finally(() => {
          this.saveLoading = false;
        });
    },
    handleNextStep() {
      this.saveMergeConfig().then(success => {
        if (success) {
          this.activeTab = "prompt";
        }
      });
    },
    startProgressPolling() {
      this.clearProgressTimer();
      this.fetchProgress();
      this.progressTimer = setInterval(() => {
        this.fetchProgress();
      }, 2500);
    },
    clearProgressTimer() {
      if (this.progressTimer) {
        clearInterval(this.progressTimer);
        this.progressTimer = null;
      }
    },
    fetchProgress() {
      if (!this.currentRecordId) return;
      return this.$http
        .get(`${requestUrl.collection.taskResultMergeProgress}/${this.currentRecordId}`)
        .then(res => {
          if (res.data && res.data.code === "0") {
            const data = res.data.data || {};
            if (data.status) {
              this.hasStarted = ["PENDING", "PROCESSING", "COMPLETED", "FAILED"].includes(data.status);
            }
            this.progressInfo = {
              progress: data.progress || 0,
              status: data.status || "",
              currentStep: data.currentStep || "",
              elapsedSeconds: data.elapsedSeconds || 0
            };
            if (data.status === "COMPLETED") {
              this.clearProgressTimer();
              // 确保 status 更新，以便 UI 逻辑正确
              this.progressInfo.status = "COMPLETED";
              
              // 同步配置信息
              this.syncStateFromRecord(data);

              // 如果进度接口已经返回了内容，合并到 resultData
              if (data.content) {
                this.resultData = { ...(this.resultData || {}), ...data };
                this.resultContent = data.content || "";
                this.$nextTick(() => {
                  this.initResultVditorLazy();
                });
                this.ensureDirectoryTreeLoaded();
              } else {
                this.fetchResult();
              }
            }
            if (data.status === "FAILED") {
              this.clearProgressTimer();
              this.progressError = "生成失败，请检查提示词或稍后重试";
            }
          } else {
            this.progressError = res.data && res.data.message ? res.data.message : "获取进度失败";
          }
        })
        .catch(error => {
          console.error("fetchProgress error:", error);
          this.progressError = "获取进度失败，请稍后重试";
        });
    },
    fetchResult() {
      if (!this.currentRecordId) return;
      this.$http
        .get(`${requestUrl.collection.taskResultMergeResult}/${this.currentRecordId}`)
        .then(res => {
          if (res.data && res.data.code === "0") {
            const data = res.data.data || {};
            
            // 同步配置信息
            this.syncStateFromRecord(data);

            this.resultContent = this.resultData.content || "";
            this.resultTitle = this.resultData.title || "";
            this.resultMarkdownHtml = this.resultContent
              ? this.markdownRenderer.render(this.resultContent)
              : "";
            this.$nextTick(() => {
              this.initResultVditorLazy();
            });
            this.ensureDirectoryTreeLoaded();
          } else {
            this.$message.error(res.data && res.data.message ? res.data.message : "获取结果失败");
          }
        })
        .catch(error => {
          console.error("fetchResult error:", error);
          this.$message.error("获取结果失败，请稍后重试");
        });
    },
    ensureDirectoryTreeLoaded() {
      if (this.directoryTreeData.length || this.directoryTreeLoading) {
        return;
      }
      this.fetchDirectoryTree();
    },
    fetchDirectoryTree() {
      if (this.directoryTreeLoading) return;
      const corpId = sessionStorage.getItem("_corpId") || "";
      const mainId = sessionStorage.getItem("_mainId") || "";
      let url = requestUrl.knowledgeBase.knowledgeBaseTree;
      url += `?corpId=${corpId}&parentId=-1&mainId=${mainId}`;
      this.directoryTreeLoading = true;
      this.$http
        .get(url)
        .then(res => {
          if (res.data && res.data.code === "0") {
            this.directoryTreeData = Array.isArray(res.data.data) ? res.data.data : [];
          } else {
            this.$message.error(res.data && res.data.message ? res.data.message : "获取知识目录失败");
          }
        })
        .catch(error => {
          console.error("fetchDirectoryTree error:", error);
          this.$message.error("获取知识目录失败，请稍后重试");
        })
        .finally(() => {
          this.directoryTreeLoading = false;
        });
    },
    getSelectedDirectoryId(directory) {
      if (!directory || typeof directory !== "object") {
        return "";
      }
      return directory.id || directory.directoryId || directory.value || "";
    },
    async getPublishTaskId() {
      const data = this.resultData || {};
      
      // 1. 优先从内存数据中获取多种可能的字段名
      let taskId = data.taskId || data.taskIds || data.taskIdList;
      
      // 2. 如果内存中没有，尝试从已选行中查找
      if (!taskId && this.selectedRows && this.selectedRows.length > 0) {
        const row = this.selectedRows.find(item => item.taskId || item.taskIds || item.taskIdList);
        if (row) {
          taskId = row.taskId || row.taskIds || row.taskIdList;
        }
      }

      // 3. 终极回退：从 sessionStorage 缓存中直接获取原始记录
      if (!taskId && this.currentRecordId) {
        try {
          const cache = JSON.parse(sessionStorage.getItem("ai_merge_record_cache") || "{}");
          const record = cache[this.currentRecordId];
          if (record) {
            taskId = record.taskId || record.taskIds || record.taskIdList;
          }
        } catch (e) {
          console.error("Failed to read cache in getPublishTaskId", e);
        }
      }

      // 4. 终极兜底：从合并结果接口获取 taskIds
      if (!taskId && this.currentRecordId) {
        try {
          const res = await this.$http.get(`${requestUrl.collection.taskResultMergeResult}/${this.currentRecordId}`);
          if (res.data && res.data.code === "0") {
            const resultData = res.data.data || {};
            taskId = resultData.taskId || resultData.taskIds || resultData.taskIdList;
          }
        } catch (e) {
          console.error("getPublishTaskId result fallback failed", e);
        }
      }

      // 处理多种数据格式（字符串、数组、逗号分隔）
      let finalTaskId = null;
      if (taskId && typeof taskId === "string") {
        // 去掉可能存在的方括号 (例如 "[121]")，防止接口报 400
        let cleanId = taskId.replace(/[\[\]]/g, "").trim();
        if (cleanId.includes(",")) {
          finalTaskId = cleanId.split(",")[0].trim();
        } else {
          finalTaskId = cleanId;
        }
      } else if (Array.isArray(taskId) && taskId.length > 0) {
        finalTaskId = String(taskId[0]);
      } else if (taskId) {
        finalTaskId = String(taskId);
      }
      
      return finalTaskId;
    },
    async publishResult() {
      if (!this.getSelectedDirectoryId(this.publishForm.directory)) {
        this.$message.warning("请选择发布目录");
        return;
      }
      const taskId = await this.getPublishTaskId();

      if (!taskId) {
        this.$message.error("无法确定任务ID，无法发布");
        return;
      }
      const folderId = this.getSelectedDirectoryId(this.publishForm.directory);
      const corpId = sessionStorage.getItem("_corpId") || "";
      const payload = {
        corpId,
        folderId,
        title: this.resultTitle,
        mergeResultContent: this.resultContent.trim()
      };
      const url = `${requestUrl.collection.taskResultMergePublish}${taskId}/publish-merge-result`;
      this.publishLoading = true;
      this.$http
        .post(url, payload)
        .then(res => {
          if (res.data && res.data.code === "0") {
            this.$message.success("发布成功");
            this.publishPopupVisible = false;
          } else {
            this.$message.error(res.data && res.data.message ? res.data.message : "发布失败");
          }
        })
        .catch(error => {
          console.error("publishResult error:", error);
          this.$message.error("发布失败，请稍后重试");
        })
        .finally(() => {
          this.publishLoading = false;
        });
    },
    openPublishPopup() {
      this.publishPopupVisible = true;
      this.ensureDirectoryTreeLoaded();
    },
    updateResult() {
      if (!this.currentRecordId) return;
      this.updateLoading = true;
      const payload = {
        recordId: this.currentRecordId,
        title: this.resultTitle,
        content: this.resultContent
      };
      this.$http
        .post(requestUrl.collection.taskResultMergeUpdate, payload)
        .then(res => {
          if (res.data && res.data.code === "0") {
            this.$message.success("保存成功");
          } else {
            this.$message.error(res.data && res.data.message ? res.data.message : "保存失败");
          }
        })
        .catch(error => {
          console.error("updateResult error:", error);
          this.$message.error("保存失败，请稍后重试");
        })
        .finally(() => {
          this.updateLoading = false;
        });
    },
    exportPdf() {
      if (!this.currentRecordId) return;
      const url = `${requestUrl.collection.taskResultMergeExportPdf}/${this.currentRecordId}`;
      window.open(url, "_blank");
    },
    getStatusText(status) {
      const map = {
        PENDING: "待处理",
        PROCESSING: "进行中",
        COMPLETED: "已完成",
        FAILED: "已失败"
      };
      return map[status] || "未知";
    },
    fetchTaskCascaderOptions() {
      // 1. 获取所有分组
      this.$http.get(requestUrl.collection.groupList).then(res => {
        if (res.data && res.data.code === "0") {
          const groups = res.data.data || [];
          // 2. 获取所有分组下的任务，并按 siteType 分类
          const typeMap = {
            WEBSITE: { label: "普通网站", value: "WEBSITE", children: [] },
            WECHAT: { label: "微信公众号", value: "WECHAT", children: [] },
            SEARCH: { label: "搜索", value: "search_engine", children: [] }
          };

          const taskPromises = groups.map(group =>
            this.$http.get(requestUrl.collection.taskList, { params: { groupId: group.id } })
          );

          Promise.all(taskPromises)
            .then(results => {
              results.forEach(taskRes => {
                if (taskRes.data && taskRes.data.code === "0") {
                  const tasks = taskRes.data.data || [];
                  tasks.forEach(task => {
                    // 获取任务类型
                    let type = (task.siteType || task.type || "").toUpperCase();
                    if (type.includes("微信") || type.includes("WECHAT")) type = "WECHAT";
                    else if (type.includes("搜索") || type.includes("SEARCH")) type = "SEARCH";
                    else type = "WEBSITE";

                    if (typeMap[type]) {
                      typeMap[type].children.push({
                        label: task.name || `任务 ${task.id}`,
                        value: task.id
                      });
                    }
                  });
                }
              });

              // 过滤掉没有子任务的类型节点，并构建最终选项
              this.taskCascaderOptions = Object.values(typeMap)
                .map(typeNode => {
                  if (typeNode.children.length === 0) {
                    delete typeNode.children;
                  }
                  return typeNode;
                });
            })
            .catch(error => {
              console.error("fetchTaskCascaderOptions tasks error:", error);
            });
        }
      }).catch(error => {
        console.error("fetchTaskCascaderOptions groups error:", error);
      });
    }
  }
};
</script>

<style scoped>
.ai-generate-create {
  width: 100%;
}

.page-header {
  margin-bottom: 16px;
}

.ai-tabs-wrapper {
  position: relative;
}

.ai-tabs {
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(31, 45, 61, 0.04);
  height: calc(100vh - 120px);
}

::v-deep .ai-tabs .el-tabs__nav-wrap {
  width: 100%;
}

::v-deep .ai-tabs .el-tabs__nav-scroll {
  overflow: visible;
}

::v-deep .ai-tabs .el-tabs__nav {
  display: flex;
  align-items: center;
  width: 100%;
}

::v-deep .ai-tabs .el-tabs__item#tab-actions {
  margin-left: auto;
  padding: 0;
  color: inherit;
  cursor: default;
}

::v-deep .ai-tabs .el-tabs__header {
  background-color: #ffffff;
  padding: 8px 20px;
  margin-bottom: 10px;
}

.tab-single {
  padding: 0px 12px 4px 4px;
  height: calc(100vh - 200px);
}

.tab-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.tab-label.is-disabled {
  color: #c0c4cc;
  cursor: not-allowed;
}

::v-deep .prompt-item .el-form-item__content {
  height: calc(100vh - 520px);
}

::v-deep .prompt-item .vditor-container,
::v-deep .prompt-item .vditor {
  height: 100%;
}

::v-deep .prompt-item .vditor-toolbar {
  padding-left: 35px;
}

.vditor-container {
  position: relative;
}

.vditor-container.is-readonly {
  /* 移除 pointer-events: none，允许滚动、选择等交互 */
}

.vditor-loading {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.9);
  z-index: 2;
  color: #606266;
}

.vditor-loading i {
  font-size: 24px;
  margin-bottom: 8px;
  color: #409eff;
}

.header-title {
  font-size: 18px;
  font-weight: 600;
  color: #1f2d3d;
}

.header-desc {
  margin-top: 6px;
  color: #6b7b8c;
  font-size: 12px;
}

.content-layout {
  display: flex;
  gap: 16px;
  background-color: #f2f6fc;
}

.left-panel {
  flex: 1.1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.right-panel {
  flex: 0.9;
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;
}

.panel-card {
  background: #ffffff;
  border-radius: 5px;
  padding: 14px 16px;
  box-shadow: 0 2px 8px rgba(31, 45, 61, 0.04);
}
.selected-box {
  height: calc(100vh - 200px);
}

.panel-title {
  font-size: 14px;
  font-weight: 600;
  color: #1f2d3d;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.panel-sub {
  font-size: 12px;
  color: #6b7b8c;
  font-weight: normal;
}

.filter-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.filter-item {
  margin-right: 2px;
}

.cascader-filter {
  width: 240px;
}

.keyword-filter {
  width: 180px;
}

.pagination-section {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}

.selected-list {
  height: calc(100vh - 240px);
  overflow-y: auto;
}

.selected-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 0;
  border-bottom: 1px dashed #e6eaf2;
}

.selected-title {
  flex: 1;
  font-size: 12px;
  color: #3c4b5f;
  margin-right: 8px;
}

.empty-tip {
  font-size: 12px;
  color: #909399;
  padding: 12px 0;
}

.merge-form .full-width {
  width: 100%;
}

.template-option {
  display: flex;
  flex-direction: column;
  line-height: 1.3;
}

.template-name {
  font-size: 13px;
}

.template-desc {
  font-size: 12px;
  color: #8a97a8;
}

.switch-tip {
  margin-left: 8px;
  font-size: 12px;
  color: #8a97a8;
}

.submit-row {
  margin-top: 8px;
  display: flex;
  gap: 10px;
}

.progress-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.progress-compact {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 320px;
  max-width: 43%;
}

.progress-row {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  justify-content: space-between;
  flex-wrap: wrap;
}

.publish-inline {
  display: flex;
  align-items: center;
  gap: 12px;
}

.result-top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.progress-error-alert {
  margin-top: 12px;
}

.mt-12 {
  margin-top: 12px;
}

.result-title-edit {
  margin-bottom: 12px;
}

.title-input ::v-deep .el-input__inner {
  font-weight: 600;
  font-size: 14px;
}

.result-actions-group {
  display: flex;
  gap: 8px;
}

.publish-popup-content {
  padding: 20px 0;
}

.publish-form-inline {
  flex: 1;
  margin-bottom: 0;
}

.publish-form-inline ::v-deep .el-form-item {
  margin-bottom: 0;
}

.publish-form-inline ::v-deep .el-form-item__label {
  font-size: 12px;
  color: #6b7b8c;
  font-weight: normal;
}

.progress-title {
  font-size: 12px;
  color: #6b7b8c;
  white-space: nowrap;
}

.progress-main {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
  min-width: 0;
}

.progress-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 12px;
  color: #6b7b8c;
}

.progress-main ::v-deep .el-progress {
  min-width: 160px;
}

.result-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
}

.result-editor {
  margin-bottom: 10px;
  height: calc(100vh - 350px);
}

::v-deep .result-editor .vditor-container,
::v-deep .result-editor .vditor {
  height: 100%;
}

.preview-title {
  font-size: 12px;
  color: #6b7b8c;
  margin-bottom: 6px;
}

.preview-body {
  max-height: 220px;
  overflow-y: auto;
  font-size: 13px;
  color: #1f2d3d;
}
</style>

<style>
.ai-generate-cascader-popper .el-cascader-menu,
.ai-generate-cascader-popper .el-cascader-menu__list,
.ai-generate-cascader-popper .el-scrollbar__view {
  width: 400px !important;
}

.ai-generate-cascader-popper .el-cascader-node__label {
  max-width: 330px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}

/* 日期快捷选项选中样式 */
.el-picker-panel__shortcut.is-active {
  background-color: #f0f7ff !important;
  color: #409eff !important;
  font-weight: 600;
}
</style>
